import React from 'react';
import BatteryEmergencyCallBottomSheet from '@di-shared/features/diag/battery/discharge/BatteryEmergencyCallBottomSheet';

function BatteryEmergencyCallBottomSheetPage() {
  return <BatteryEmergencyCallBottomSheet />;
}

export default BatteryEmergencyCallBottomSheetPage;
